var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-content" }, [
    _c("div", { staticClass: "modal-header" }, [
      _c(
        "h4",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel" } },
        [_vm._v(_vm._s(_vm.popupTitle))]
      )
    ]),
    _c("div", { staticClass: "modal-body" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            { staticClass: "control-label", attrs: { for: "paramname" } },
            [_vm._v(_vm._s(_vm._f("translate")("Parameter name")))]
          ),
          _c("div", {}, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.parameterRow.parameter,
                  expression: "parameterRow.parameter"
                }
              ],
              staticClass: "form-control",
              attrs: { name: "paramname", type: "text", size: "20" },
              domProps: { value: _vm.parameterRow.parameter },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.parameterRow, "parameter", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            { staticClass: "control-label ", attrs: { for: "targetquestion" } },
            [_vm._v(_vm._s(_vm._f("translate")("Target question")))]
          ),
          _c("div", {}, [
            _c(
              "select",
              {
                staticClass: "form-control",
                attrs: { name: "targetquestion", size: "1" },
                on: {
                  change: function($event) {
                    return _vm.updateValues($event)
                  }
                }
              },
              [
                _c("option", { attrs: { value: "" } }, [
                  _vm._v(_vm._s(_vm._f("translate")("No target question")))
                ]),
                _vm._l(_vm.availableQuestions, function(question, index) {
                  return _c("option", {
                    key: question.qid,
                    domProps: {
                      value: index,
                      selected: question.qid == _vm.parameterRow.qid,
                      innerHTML: _vm._s(_vm.printQuestion(question))
                    }
                  })
                })
              ],
              2
            )
          ])
        ]),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.parameterRow.qid,
                expression: "parameterRow.qid"
              }
            ],
            attrs: { type: "hidden" },
            domProps: { value: _vm.parameterRow.qid },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.parameterRow, "qid", $event.target.value)
              }
            }
          }),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.parameterRow.sqid,
                expression: "parameterRow.sqid"
              }
            ],
            attrs: { type: "hidden" },
            domProps: { value: _vm.parameterRow.sqid },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.parameterRow, "sqid", $event.target.value)
              }
            }
          })
        ]),
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "col-sm-12 text-center" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success",
                class: !_vm.isValid ? "disabled" : "",
                attrs: { disabled: !_vm.isValid },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.saveChangedParameter()
                  }
                }
              },
              [
                _c("span", { staticClass: "fa fa-floppy-o" }),
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm._f("translate")("Save")) +
                    "\n                    "
                )
              ]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.cancelEditParameter()
                  }
                }
              },
              [_vm._v(_vm._s(_vm._f("translate")("Cancel")))]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }